import React, { useState, useEffect, useRef, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'

import {
   Box,
   Button,
   Card,
   CardContent,
   Divider,
   Grid,
   Typography,
   TextField
} from '@material-ui/core'
// import Remove from '@material-ui/icons/Remove'
// import Add from '@material-ui/icons/Add'

import logo from '../../assets/images/logo.jpg'

// api
import { postPublicAPI, getPublicAPI } from '../../api'

import { ShoppingCartContext } from '../../contexts/ShoppingCart'
import { ToastContext } from '../../contexts/Toast'

const ProductCard = ({ product, home, ...rest }) => {
   let mounted = useRef(true)
   const navigate = useNavigate()

   const { shopping, setShopping } = useContext(ShoppingCartContext)
   const { setToasts } = useContext(ToastContext)
   const [quantity, setQuantity] = useState(0)
   const [cart, setCart] = useState(true)
   const [productPrice, setProductPrice] = useState()

   const [feets, setFeets] = useState(0)
   const [inches, setInches] = useState(0)

   let customerId = localStorage.getItem('user_id')
   let userType = localStorage.getItem('user_type')

   // const onInchIncrement = () => {
   //    if (inches >= 11) {
   //       setInches(0)
   //       setFeets(feets + 1)
   //    } else setInches(inches + 1)
   // }

   // const onInchDecrement = () => {
   //    if (inches === 1 && feets === 0) setInches(0)
   //    else {
   //       if (inches <= 0 && feets > 0) {
   //          setInches(11)
   //          setFeets(feets - 1)
   //       } else if (inches > 0) setInches(inches - 1)
   //    }
   // }

   // const onIncrement = () =>
   //    product.type === 'hose' ? setFeets(feets + 1) : setQuantity(quantity + 1)

   // const onDecrement = () =>
   //    product.type === 'hose'
   //       ? feets > 0
   //          ? setFeets(feets - 1)
   //          : null
   //       : quantity > 0
   //       ? setQuantity(quantity - 1)
   //       : null

   const onQuantityChange = value => setQuantity(value)
   const onFeetsChange = value => setFeets(value)
   const onInchesChange = value => setInches(value)

   const handleSubmit = () =>
      home ? navigate('/product/' + product.rhpn) : navigate('/app/product/' + product.rhpn)

   const addToCart = async () => {
      mounted.current && setCart(false)

      try {
         let quantityInfo = product.type === 'hose' ? feets + '-' + inches : quantity

         const data = {
            quantity: quantityInfo,
            productId: product.rhpn,
            user: localStorage.user_email || localStorage.ip_address
         }

         let addedToCart = await postPublicAPI('/add-to-cart', data)
         if (addedToCart?.success) {
            setToasts({
               type: 'success',
               messages: [{ msg: `${product.rhpn} added to cart` }]
            })

            setShopping(!shopping)
         } else setToasts({ type: 'error', messages: addedToCart?.errors })
      } catch (err) {
         setToasts({ type: 'error', messages: [{ msg: `error in adding to cart ${err.message}` }] })
      } finally {
         mounted.current && setCart(true)
         mounted.current && setQuantity(0)
         mounted.current && setFeets(0)
         mounted.current && setInches(0)
      }
   }

   useEffect(() => {
      async function getUserData() {
         if (localStorage.auth_token) {
            let userData = await getPublicAPI(`/user/${customerId}`)
            if (userData?.success) {
               let calculatedPrice = (product.lPrice * userData?.data?.discountValue) / 100
               let discountedPrice = Math.round(calculatedPrice * 100) / 100
               let newPrice = (product.lPrice - discountedPrice).toFixed(2)
               setProductPrice(newPrice)
            }
         }
      }

      getUserData()
      return () => (mounted.current = false)
   }, [customerId, product.lPrice])

   useEffect(() => {
      const myQuantity = document.getElementById('quantity-' + product.rhpn)
      if (myQuantity)
         myQuantity.addEventListener('keypress', function (evt) {
            let value = myQuantity.value.toString()
            if (value[0] === '0') {
               evt.preventDefault()
            }
            if (evt.which < 48 || evt.which > 57) {
               evt.preventDefault()
            }
         })

      const myFeets = document.getElementById('feets-' + product.rhpn)
      if (myFeets)
         myFeets.addEventListener('keypress', function (evt) {
            let value = myFeets.value.toString()
            if (value[0] === '0') {
               evt.preventDefault()
            }
            if (evt.which < 48 || evt.which > 57) {
               evt.preventDefault()
            }
         })

      const myInches = document.getElementById('inches-' + product.rhpn)
      if (myInches)
         myInches.addEventListener('keypress', function (evt) {
            let value = myInches.value.toString()
            if (value[0] === '0') {
               evt.preventDefault()
            }
            if (evt.which < 48 || evt.which > 57) {
               evt.preventDefault()
            }
         })
   }, [product.rhpn])

   return (
      <Card
         sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%'
         }}
         {...rest}
      >
         <CardContent onClick={handleSubmit}>
            <Box
               sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  pb: 3
               }}
               className='product-image-container'
            >
               <img
                  className='products-image'
                  alt={product.rhpn}
                  src={product.pictures?.length > 0 ? product.pictures[0] : logo}
               />
            </Box>
            <Typography color='textPrimary' gutterBottom variant='h4'>
               {'Part #: ' + product.rhpn}
            </Typography>
            <Typography color='textPrimary' variant='body1'>
               {product.rhpn + ' | ' + product.desc}
            </Typography>
         </CardContent>
         <Box sx={{ flexGrow: 1 }} />
         <Divider />
         <Box sx={{ p: 2 }}>
            {product.type === 'hose' && (
               <Typography>
                  Price per feet: ${userType === 'customer' ? productPrice : product.lPrice}
               </Typography>
            )}
            <Grid container spacing={2} sx={{ justifyContent: 'space-between' }}>
               <Grid
                  item
                  sx={{
                     alignItems: 'center',
                     display: 'flex'
                  }}
               >
                  <Typography color='textPrimary' display='inline' variant='body2'>
                     Catalog: ${product.lPrice}
                  </Typography>
               </Grid>
               <Grid
                  item
                  sx={{
                     alignItems: 'center',
                     display: 'flex'
                  }}
               >
                  <Typography color='#D22F25' display='inline' variant='body2'>
                     Online: ${userType === 'customer' ? productPrice : product.lPrice}
                  </Typography>
               </Grid>
            </Grid>
         </Box>
         <Divider />
         {(localStorage.user_type === 'customer' ||
            (localStorage.ip_address && !localStorage.auth_token)) && (
            <Box sx={{ p: 2 }}>
               {product.type === 'hose' ? (
                  <Box>
                     <Typography color='#D22F25' display='inline' variant='body2'>
                        Please fill in the length:
                     </Typography>
                     <Grid
                        container
                        sx={{
                           justifyContent: 'space-between',
                           alignItems: 'center',
                           mb: 2,
                           mt: 1
                        }}
                     >
                        <TextField
                           id={`feets-${product.rhpn}`}
                           label='Feets'
                           fullWidth
                           value={feets || ''}
                           autoComplete={false}
                           onChange={e => {
                              if (
                                 (e.target.value === '0' && inches === '0') ||
                                 (e.target.value === '0' && inches === '')
                              ) {
                                 setToasts({
                                    type: 'error',
                                    messages: [{ msg: 'Enter a value of atleast 1' }]
                                 })
                              }
                              onFeetsChange(e.target.value)
                           }}
                        />
                     </Grid>
                     <Grid
                        container
                        sx={{
                           justifyContent: 'space-between',
                           alignItems: 'center',
                           mb: 2
                        }}
                     >
                        <TextField
                           id={`inches-${product.rhpn}`}
                           label='Inches'
                           fullWidth
                           value={inches || ''}
                           autoComplete={false}
                           onChange={e => {
                              if (
                                 (e.target.value === '0' && feets === '0') ||
                                 (e.target.value === '0' && feets === '')
                              ) {
                                 setToasts({
                                    type: 'error',
                                    messages: [{ msg: 'Enter a value of atleast 1' }]
                                 })
                              }
                              onInchesChange(e.target.value)
                           }}
                        />
                     </Grid>
                     {/* <Typography color='#D22F25' display='inline' variant='body1'>
                        Feets:
                     </Typography>
                     <Grid
                        container
                        sx={{
                           justifyContent: 'space-between',
                           alignItems: 'center',
                           mb: 2
                        }}
                     >
                        <Button
                           className='product-actions'
                           item='true'
                           onClick={onDecrement}
                           variant='contained'
                        >
                           <Remove color='textPrimary' />
                        </Button>
                        <Grid>
                           <Typography color='#D22F25' display='inline' variant='body1'>
                              {feets}
                           </Typography>
                        </Grid>
                        <Button
                           className='product-actions'
                           item='true'
                           onClick={onIncrement}
                           variant='contained'
                        >
                           <Add color='textPrimary' />
                        </Button>
                     </Grid>
                     <Typography color='#D22F25' display='inline' variant='body2'>
                        Inches:
                     </Typography>
                     <Grid
                        container
                        sx={{
                           justifyContent: 'space-between',
                           alignItems: 'center',
                           mb: 2
                        }}
                     >
                        <Button
                           className='product-actions'
                           item='true'
                           onClick={onInchDecrement}
                           variant='contained'
                        >
                           <Remove color='textPrimary' />
                        </Button>
                        <Grid>
                           <Typography color='#D22F25' display='inline' variant='body2'>
                              {inches}
                           </Typography>
                        </Grid>
                        <Button
                           className='product-actions'
                           item='true'
                           onClick={onInchIncrement}
                           variant='contained'
                        >
                           <Add color='textPrimary' />
                        </Button>
                     </Grid> */}
                  </Box>
               ) : (
                  <Grid container sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                     <Typography color='#D22F25' display='inline' variant='body2' sx={{ mb: 1 }}>
                        Please fill in the quantity:
                     </Typography>
                     <TextField
                        id={`quantity-${product.rhpn}`}
                        label='Quantity'
                        fullWidth
                        value={quantity || ''}
                        autoComplete={false}
                        onChange={e => {
                           if (e.target.value === '0') {
                              setToasts({
                                 type: 'error',
                                 messages: [{ msg: 'Enter a value of atleast 1' }]
                              })
                           }
                           onQuantityChange(e.target.value)
                        }}
                     />
                     {/* <Button className='product-actions' item='true' onClick={onDecrement}>
                        <Remove color='action' />
                        </Button>
                        <Grid>
                           <Typography color='#D22F25' display='inline' variant='body2'>
                              Quantity:
                           </Typography>
                        </Grid>
                     <Button className='product-actions' item='true' onClick={onIncrement}>
                        <Add color='action' />
                     </Button> */}
                  </Grid>
               )}
               {(quantity && quantity > 0) || (feets && feets > 0) || (inches && inches > 0) ? (
                  <Grid container sx={{ pt: 1, justifyContent: 'center', alignItems: 'center' }}>
                     <Button
                        className='add-to-cart-button'
                        onClick={addToCart}
                        disabled={!cart}
                        color={cart ? 'primary' : 'action'}
                        variant='contained'
                     >
                        Add to Cart
                     </Button>
                  </Grid>
               ) : (
                  <></>
               )}
            </Box>
         )}
      </Card>
   )
}

ProductCard.propTypes = {
   product: PropTypes.object.isRequired
}

export default ProductCard
